import InputMask from 'react-input-mask';

const colorMappings = {
    primary: "blue",
    secondary: "zinc",
    danger: "red",
    success: "green",
}
const TwInputDate = ({ value, label, onChange, onKeyDown, defaultValue, size, placeholder, inputProps, direction, width }) => {
    const cssClass = [
        // "mb-4"
    ]
    if (direction != "ltr") {
        cssClass.push("rtl")
    }
    const cssClasses = [
        "ltr",
        "shadow",
        "appearance-none",
        "border",
        "rounded",
        "w-full",
        "py-1",
        "px-2",
        "text-gray-700",
        "dark:text-gray-300",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "bg-transparent",
    ]
    return <div className={cssClass.join(" ")} style={{ width: width }}>
        {label && <label className="block text-gray-700 dark:text-gray-500 text-sm text-sm mb-2">{label}</label>}
        <InputMask
            mask="9999/99/99"
            value={value}
            defaultValue={defaultValue}
            onChange={(e) => onChange && onChange(e.target.value)}
            >
            {(inputProps) => (
                <input
                    dir="ltr"
                    onKeyDown={onKeyDown}
                    {...inputProps}
                    className={cssClasses.join(" ")}
                    type="text"
                    placeholder="14../../.."
                />
            )}
        </InputMask>
    </div>;
};
export const TwInputDateTime = ({ value, label, onChange, onKeyDown, defaultValue, size, placeholder, inputProps, direction, width }) => {
    const cssClass = [
        // "mb-4"
    ]
    if (direction != "ltr") {
        cssClass.push("rtl")
    }
    const cssClasses = [
        "ltr",
        "shadow",
        "appearance-none",
        "border",
        "rounded",
        "w-full",
        "py-1",
        "px-2",
        "text-gray-700",
        "dark:text-gray-300",
        "leading-tight",
        "focus:outline-none",
        "focus:shadow-outline",
        "bg-transparent",
    ]
    return <div className={cssClass.join(" ")} style={{ width: width }}>
        {label && <label className="block text-gray-700 dark:text-gray-500 text-sm text-sm mb-2">{label}</label>}
        <InputMask
            mask="9999/99/99 99:99:99"
            value={value}
            defaultValue={defaultValue}
            onChange={(e) => onChange && onChange(e.target.value)}
            >
            {(inputProps) => (
                <input
                    dir="ltr"
                    onKeyDown={onKeyDown}
                    {...inputProps}
                    className={cssClasses.join(" ")}
                    type="text"
                    placeholder="14../../.. ..:..:.."
                />
            )}
        </InputMask>
    </div>;
};

export default TwInputDate;
